<mat-card
  class="relative w-full h-[280px] md:h-[312px] flex flex-col"
  appearance="raised"
  [attr.data-testid]="'offer-status-' + offer.id"
>
  @if (showContextMenu) {
    <div class="absolute top-2 right-2 z-1000">
      <button
        class="text-gray-500 hover:text-gray-700 focus:outline-none"
        [matMenuTriggerFor]="menu"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        @if (offer.status !== "REJECTED") {
          <button [routerLink]="['/edit', offer.id]" mat-menu-item>
            <mat-icon>edit</mat-icon>
            <span i18n>Bearbeiten</span>
          </button>
        }
        @if (
          offer.status !== "REJECTED" && (userIsAdvisoryboard || userIsAdmin)
        ) {
          <button [routerLink]="['/feedback', offer.id]" mat-menu-item>
            <mat-icon>feedback</mat-icon>
            <span i18n>Feedback</span>
          </button>
        }
        @if (offer.status !== "REJECTED" && userIsCompany) {
          <button [routerLink]="['/feedback-history', offer.id]" mat-menu-item>
            <mat-icon>history</mat-icon>
            <span i18n>Feedback Historie</span>
          </button>
        }
        <button (click)="openDeleteModal()" mat-menu-item>
          <mat-icon>delete</mat-icon>
          <span i18n>Löschen</span>
        </button>
      </mat-menu>
    </div>
  }

  @if (isModalOpen) {
    <div
      class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50"
      id="my-modal"
    >
      <div
        class="relative top-20 mx-auto p-5 border w-[90%] sm:w-[400px] h-[220px] shadow-lg rounded-md bg-white flex flex-col justify-between"
      >
        <div
          class="flex flex-col justify-center items-center flex-grow text-center"
        >
          <h3 class="text-lg leading-6 font-medium text-gray-900" i18n>
            Möchtest du das Angebot wirklich löschen?
          </h3>
          <p class="mt-2 text-sm text-gray-500" i18n>
            Diese Aktion kann nicht rückgängig gemacht werden.
          </p>
        </div>
        <div class="flex justify-between items-center mt-6">
          <button
            (click)="closeDeleteModal()"
            class="px-6 py-2 bg-gray-300 text-black font-semibold rounded-full hover:bg-gray-400 focus:outline-none"
            i18n
          >
            Abbrechen
          </button>
          <button
            (click)="confirmDelete()"
            class="px-6 py-2 bg-red-600 text-white font-semibold rounded-full hover:bg-red-700 focus:outline-none"
            i18n
          >
            Ja, löschen
          </button>
        </div>
      </div>
    </div>
  }

  <app-offer-media-display
    [offer]="offer"
    class="h-32 md:h-40 overflow-hidden hover:cursor-pointer"
    [routerLink]="['/details', offer.id]"
  ></app-offer-media-display>
  <mat-card-content
    [routerLink]="['/details', offer.id]"
    class="hover:cursor-pointer max-h-[15%]"
  >
    <div class="pt-4">
      <mat-card-title>
        <span class="text-sm md:text-lg font-semibold text-left">
          {{ offer.name }}
        </span>
      </mat-card-title>
      <p
        class="mt-2 text-xs md:text-sm text-left text-gray-600 line-clamp-2 whitespace-pre-line"
        [innerHTML]="stripHtmlPreserveNewlines(offer.description)"
      ></p>
    </div>
  </mat-card-content>

  @if (showActions) {
    <mat-card-actions class="justify-center hover:cursor-pointer">
      @if (fromAdvisoryBoard) {
        <div
          class="flex items-center justify-center absolute bottom-2 outline outline-2 outline-gray-300 rounded-full p-2 bg-white"
          [routerLink]="['/feedback', offer.id]"
        >
          <mat-icon>feedback</mat-icon>
          <span> Jetzt Feedback geben </span>
        </div>
      }
      @if (showStatus && !fromAdvisoryBoard) {
        <div
          [ngClass]="getStatusDetails(offer.status).colorClass"
          class="text-white text-xs font-semibold px-2 py-1 rounded-full ml-auto absolute bottom-2 right-2"
        >
          {{ getStatusDetails(offer.status).text }}
        </div>
      }
    </mat-card-actions>
  }
</mat-card>
